// extracted by mini-css-extract-plugin
module.exports = {"cardColumn":"Uploads_cardColumn__2GS9I","cardList":"Uploads_cardList__3fWqp","card":"Uploads_card__2PrMJ","title":"Uploads_title__3OUa0"};